import React from 'react';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { Col, Row } from 'react-bootstrap';
import SponsorUserInfo from './SponsorUserInfo';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as FormManager from 'fw/forms/form/FormManager';
import * as Help from 'modules/app/Help';
import * as App from 'modules/app/App';


const columns = [
    { key: 'firstName', name: 'First Name', width: 150 },
    { key: 'lastName', name: 'Last Name', width: 150 },
    { key: 'title', name: 'Title', width: 150 },
    { key: 'email', name: 'Email' },
	{ key: 'primaryContact', name: 'Primary Contact', formatter: Formatter.Check, width: 120, cellClass: "text-center" },
	{ key: 'adminRights', name: 'Admin Rights', formatter: Formatter.Check, width: 100, cellClass: "text-center" },
    { key: 'registrationComplete', name: 'Reg. Complete', formatter: Formatter.Check, width: 110, cellClass: "text-center" },
    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 60, cellClass: "text-center" }
];

class SponsorUsersTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = (props) => {
        return {
            loading: true,
            rows: [],
            sponsorId: null,
            userId: null
        };
    }

    load = () => {
        // Nothing to load on this tab
    }

    setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
    }

    componentDidMount() {
        this.get();
        this.setHelp();
    }

    get = () => {
        this.search();
    }

    resetUser = () => {
        this.setState({ userId: null });
    }

    search = () => {
        let me = this;

        new API().post(APIModules.Sponsor.url('/sponsorSetup/getSponsorManagementUsers'), {},
            {
                success: (r) => {
                    let rows = r.data.items;

                    // Store search results
                    this.setState({
                        rows: rows,
                        loading: false,
                        sponsorId: r.data.sponsorId,
                    }, me.resetUser());
                },
                error: r => {
                    this.setState({ loading: false });
                }
            });
    }

    goToUserDetails = () => {
        setTimeout(() => {
            window.scrollTo({
                behavior: "smooth",
                top: this._userDetail.offsetTop
            });
        }, 200);
    }

    onEditUser = (userId) => {
        FormManager.checkUnsavedChanges(() => {
            this.setState({ userId: userId }, () => { this.goToUserDetails() });
        });
    }

    handleUserUpdate = () => {
        this.search();
    }

    handleUserCancel = () => {
        this.resetUser();
    }

    handleAddUser = () => {
		FormManager.checkUnsavedChanges(() => {
            this.setState({ userId: 0 }, () => { this.goToUserDetails() });
        })
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 className="inline">
                            Corporate Member Information <small>These are the users associated with the Corporate Member</small>
                        </h3>
                        {this.state.sponsorId !== null && this.state.sponsorId !== undefined && App.hasPrivilege("SponsorSetupUserAdd") ? 
                            <span className="pull-right" style={{ textAlign: "right" }}>
                                <Button id="btnAddNew" bsStyle="success" className="pull-right" style={{ marginRight: 0 }}
                                    onClick={this.handleAddUser} disabled={this.state.userId === 0}>Add new user</Button>
                            </span>
                        :null}
                        <br /><br /><hr />
                    </Col>
                </Row>
                {this.state.sponsorId !== null && this.state.sponsorId !== undefined ? 
                    <React.Fragment>
                        <Row>
                            <Col md={12}>
                                {!this.state.loading ?
                                    <Grid
                                        ref={(c) => { this._grid = c }}
                                        columns={columns}
                                        items={this.state.rows}
                                        height={250}
                                        className="table-condensed"
                                        rowKey="userId"
                                        onChange={this.onEditUser}
                                        name="default" />
                                    : null}
                            </Col>
                        </Row>
                        {this.state.userId !== null &&
                            <React.Fragment>
                                <Row>
                                    <Col md={12}>
                                        {<SponsorUserInfo
                                            sponsorId={this.state.sponsorId}
                                            userId={this.state.userId}
                                            onUpdate={this.handleUserUpdate}
                                            onCancel={this.handleUserCancel}
                                        />}
                                    </Col>
                                </Row>
                                <div ref={(c) => { this._userDetail = c }}>
                                </div>
                            </React.Fragment>
                        }
                    </React.Fragment>
                :
                    <Row>
                        {!this.state.loading ?
                            <Col md={12} className="text-center">
                                <h4 style={{ color: 'red' }}>
                                    The user is not assigned to any sponsor yet.
                                </h4>
                                <h4>
                                    Please contact <a href='mailto:certification@nvbdc.org'>certification@nvbdc.org</a> for more assistance.
                                </h4>
                            </Col>
                        :null}
                    </Row>
                }
            </React.Fragment>
        )
    }
}

export default SponsorUsersTab;


// WEBPACK FOOTER //
// ./src/areas/sponsor/sponsorSetup/users/SponsorUsersTab.js